var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Autocomplete, Box, Checkbox, Chip, FormControl, IconButton, Stack, TextField, Typography } from '@mui/material';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Button from "@mui/material/Button";
import { useLocalize } from "../../utils/text.util";
import { CommonThemeColors } from "../theme";
var icon = _jsx(CheckBoxOutlineBlankIcon, { fontSize: "small" });
var checkedIcon = _jsx(CheckBoxIcon, { fontSize: "small" });
var ColumnSelect = function (_a) {
    var columns = _a.columns, allColumns = _a.allColumns, onChange = _a.onChange, forceOpen = _a.forceOpen;
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var t = useLocalize().t;
    var handleClose = function () {
        setOpen(false);
    };
    var handleOpen = function () {
        setOpen(true);
    };
    // Only for reservation sectors
    if (forceOpen) {
        var allSelected_1 = allColumns.every(function (col) { return columns.some(function (c) { return c.id === col.id; }); });
        return (_jsxs(Stack, __assign({ direction: 'column' }, { children: [_jsxs(Stack, __assign({ direction: "row", justifyContent: 'space-between', alignItems: "center", padding: 1, gap: 5 }, { children: [_jsx(Typography, __assign({ variant: 'body1', color: CommonThemeColors.sys.text.secondary }, { children: t('Select columns') })), _jsx(Button, __assign({ size: "small", color: "info", onClick: function () {
                                onChange(allSelected_1 ? [] : __spreadArray([], allColumns, true));
                            } }, { children: allSelected_1 ? t('Deselect all') : t('Select all') }))] })), _jsx(Box, __assign({ sx: {
                        padding: 1,
                        minWidth: 400,
                        maxWidth: 400
                    } }, { children: _jsx(Autocomplete, { multiple: true, options: allColumns, value: columns, onChange: function (_event, newValue) {
                            onChange(newValue);
                        }, getOptionLabel: function (option) { return option.name; }, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, disableCloseOnSelect: true, renderOption: function (props, option, _a) {
                            var selected = _a.selected;
                            return (_createElement("li", __assign({}, props, { key: option.id, style: __assign(__assign({}, props.style), { paddingTop: 1, paddingBottom: 1 }) }),
                                _jsx(Checkbox, { icon: icon, checkedIcon: checkedIcon, style: { marginRight: 8 }, checked: selected }),
                                option.name));
                        }, renderTags: function (value, getTagProps) {
                            return value.map(function (option, index) { return (_createElement(Chip, __assign({}, getTagProps({ index: index }), { key: option.id, label: option.name, size: "small" }))); });
                        }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { variant: "outlined", size: "small", placeholder: columns.length === 0 ? t('Select columns') : '' }))); }, slotProps: {
                            paper: {
                                sx: {
                                    maxHeight: 'none',
                                    boxShadow: 'none',
                                    overflow: 'visible',
                                }
                            }
                        } }) }))] })));
    }
    var allSelected = allColumns.every(function (col) { return columns.some(function (c) { return c.id === col.id; }); });
    return (_jsxs(FormControl, __assign({ sx: { position: 'relative' } }, { children: [_jsx(IconButton, __assign({ onClick: handleOpen }, { children: _jsx(ViewColumnIcon, { color: "secondary" }) })), open && (_jsxs(Box, __assign({ sx: {
                    position: 'absolute',
                    top: '100%',
                    left: '50%',
                    transform: 'translateX(0%)',
                    zIndex: 1300,
                    minWidth: 300,
                    bgcolor: 'background.paper',
                    boxShadow: 3,
                    borderRadius: 1,
                    p: 1,
                } }, { children: [_jsxs(Stack, __assign({ direction: "row", justifyContent: 'space-between', alignItems: "center", padding: 1, gap: 5 }, { children: [_jsx(Typography, __assign({ variant: 'body1', color: CommonThemeColors.sys.text.secondary }, { children: t('Select columns') })), _jsx(Button, __assign({ size: "small", color: "info", onClick: function () {
                                    onChange(allSelected ? [] : __spreadArray([], allColumns, true));
                                } }, { children: allSelected ? t('Deselect all') : t('Select all') }))] })), _jsx(Autocomplete, { multiple: true, open: true, options: allColumns, value: columns, onChange: function (_event, newValue) {
                            onChange(newValue);
                        }, getOptionLabel: function (option) { return option.name; }, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, disableCloseOnSelect: true, renderOption: function (props, option, _a) {
                            var selected = _a.selected;
                            return (_createElement("li", __assign({}, props, { key: option.id }),
                                _jsx(Checkbox, { icon: icon, checkedIcon: checkedIcon, style: { marginRight: 8 }, checked: selected }),
                                option.name));
                        }, renderTags: function (value, getTagProps) {
                            return value.map(function (option, index) { return (_createElement(Chip, __assign({}, getTagProps({ index: index }), { key: option.id, label: option.name, size: "small" }))); });
                        }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { variant: "outlined", size: "small", placeholder: columns.length === 0 ? t('Select columns') : '', autoFocus: true }))); }, slotProps: {
                            paper: {
                                sx: {
                                    boxShadow: 'none',
                                    maxHeight: 'none',
                                    overflow: 'hidden',
                                }
                            },
                        }, ListboxProps: {
                            style: {
                                maxHeight: '300px',
                                overflowY: 'auto',
                            }
                        } })] }))), open && (_jsx(Box, { sx: { position: 'fixed', inset: 0, zIndex: 1299 }, onClick: handleClose }))] })));
};
export default ColumnSelect;
